module.exports = __webpack_public_path__ + "img/bg.c2da6ef0.jpg";